const DOMAIN = "https://amcdn.msftauth.net";

export interface EndpointParams {
    /** The partner ID for the requesting partner */
    partner: string;
    /** The language code the Me Control should render in (e.g. en-us, ar-SA). */
    market?: string;
    /** Whether or not to return unminified scripts useful for debugging */
    debug?: boolean;
    /** The ID of any framework or library that is wrapping the Me Control (e.g. uhf, suiteshell). */
    wrapperId?: string;
    /** Override the default version of the Me Control and request a specific version */
    version?: string;
}

// Note: "latest" will be replaced with the package version when we run the
// package and publish to npm tasks. This value is used by Office SuiteShell
// to control the rollout of new versions of the Me Control
export const CURRENT_VERSION = "latest";

/**
 * Get the endpoint to download the Me Control JavaScript from
 * @param [params] Optional parameters to pass to the Me Control URL
 */
export function getEndpoint(params: EndpointParams = {} as any): string {
    let url = `${DOMAIN}/me`;

    let paramArray: string[] = [];
    if (params.partner) {
        paramArray.push(`partner=${params.partner}`);
    }

    if (params.version) {
        paramArray.push(`version=${params.version}`);
    }

    if (params.market) {
        paramArray.push(`market=${params.market}`);
    }

    if (params.debug) {
        paramArray.push(`debug=true`);
    }

    if (params.wrapperId) {
        paramArray.push(`wrapperId=${params.wrapperId}`);
    }

    let queryString = paramArray.join('&');
    return url + (queryString ? '?' + queryString : '');
}
